var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChatbotEnabled && _vm.chatbotApiKey)?_c('div',{ref:"widgetContainer"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }